import { ReactElement } from 'react';
import parse, { domToReact, HTMLReactParserOptions } from 'html-react-parser';

import {
  isElement,
  renderPasteComponentByHtmlTag,
  renderPasteComponentByClassName,
} from './utils';
import { useSegment } from '../../hooks';
import { types } from './definitions';

// Uses `html-react-parser`(https://github.com/remarkablemark/html-react-parser)
const HtmlStringToPaste = ({
  htmlString,
}: types.HtmlStringToPasteProps): ReactElement => {
  const { trackEvent } = useSegment();
  const options: HTMLReactParserOptions = {
    replace: (node) => {
      if (isElement(node)) {
        const attributes = node.attribs;
        const childElements = domToReact(node.children, options);
        const htmlTag = node.name;
        const parentElement = node.parentNode;

        return (
          renderPasteComponentByClassName({
            attributes,
            childElements,
          }) ||
          renderPasteComponentByHtmlTag({
            attributes,
            childElements,
            parentElement,
            htmlTag,
            trackEvent,
          })
        );
      }
    },
  };

  return <>{parse(htmlString, options)}</>;
};

export default HtmlStringToPaste;
